import { useContext } from "react";

import ProductContext from "./ProductContext";

export const useProductContext = () => useContext(ProductContext);
